export default {
  faqTitle: 'Atlas Mutuel Sigorta Hakkında Merak Edilen Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  products: {
    title: 'Atlas Mutuel Sigorta Ürünleri',
    buttons: [
      {
        id: 1,
        title: 'KASKO SİGORTASI',
        class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
        path: 'AtlasMutuelMotorInsurance'
      },
      {
        id: 2,
        title: 'KONUT SİGORTASI',
        class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
        path: 'AtlasMutuelHomeInsurance'
      },
      {
        id: 3,
        title: 'DASK SİGORTA',
        class: 'company--btn--icons fas fa-laptop fa-2x mr-2',
        path: 'AtlasMutuelDask'
      },
      {
        id: 4,
        title: 'İŞYERİ SİGORTASI',
        class: 'company--btn--icons fas fa-building fa-2x mr-2',
        path: 'AtlasMutuelCompanyInsurance'
      },
      {
        id: 5,
        title: 'FERDİ KAZA SİGORTASI',
        class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
        path: 'AtlasMutuelPersonalAccident'
      },
      {
        id: 6,
        title: 'NAKLİYAT SİGORTASI',
        class: 'company--btn--icons fas fa-dolly-flatbed fa-2x mr-2',
        path: 'AtlasMutuelTransportation'
      },
      {
        id: 7,
        title: 'SEYAHAT SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
        path: 'AtlasMutuelTravelInsurance'
      }
    ]
  },
  introContent: {
    title: 'Atlas Mutuel Sigorta Hakkında',
    content: [
      {
        paragraph:
          'Atlas Mutuel Sigorta %100 yerli sermayeli sigorta şirketidir. Genel merkezi İzmir’de bulunan Atlas Mutuel Sigorta, güçlü kadrosu ile birlikte müşterilerine kapsamlı hizmet sunma yolunda ilerlemektedir.'
      },
      {
        paragraph:
          'Atlas Mutuel Sigorta, Mapfre Re, Royal Sun Alliance Re, Milli Re gibi güçlü ve güvenilir Reasürörlerinin desteğini almıştır. Güçlü yapısı ile hizmet verdiği branşlar doğrultusunda en hızlı desteği sigortalılarına sunmaktadır.'
      },
      {
        paragraph:
          'Oto ve oto dışı branşlarda hizmet veren Atlas Mutuel Sigorta’nın ürünlerini inceleyerek en doğru fiyatlarına ulaşmak için doğru adrestesiniz.'
      }
    ]
  },
  questions: [
    {
      title: 'Atlas Mutuel Sigorta Ürün Çeşitleri Nelerdir?',
      content: [
        {
          title:
            'Yerli sigorta şirketi müşterilerine 15’ten fazla sigorta branşında hizmet vermektedir. Branş bazında geniş kapsama ayrılan ürün paketleri sayesinde hem istediğiniz kapsama kolay erişim sağlayabiliyor hem de talep ettiğiniz en uygun fiyatı değerlendirme şansınız artıyor.',
          subList: null
        },
        {
          paragraph:
            'Alokasko aracılığıyla Atlas Mutuel Sigorta’dan fiyat teklifi alabileceğiniz bazı ürünler;',
          subList: [
            'Araç Kasko Sigortası',
            'Konut Paket Yangın Sigortası',
            'İşyeri Paket Yangın Sigortası',
            'Ferdi Kaza Sigortası',
            'Nakliyat Emtia Sigortası',
            'Seyahat Sağlık Sigortası.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Mutuel Sigorta Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Atlas Mutuel Kasko Sigortası aracınızın uğrayacağı zarar ve hasarları güvence altına alarak, bütçenizi korur. Aracınız kamyonet ve hususi araç grubunda yer alıyorsa Atlas Mutuel güvencesinde kasko poliçenizi satın alabilir ve teminat kapsamınızı hemen başlatabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Kasko branşında 3 farklı sigorta paketi yer almaktadır. Bunlar:',
          subList: [
            ' Bireysel Kasko Sigortası',
            ' Ticari Kasko Sigortası',
            ' Rent A Car Kasko Sigortası.'
          ]
        },
        {
          paragraph:
            'Atlas Mutuel Kasko Sigortası kapsamında sunulan mini onarım teminatı ve ikame araç teminatı araç sürücülerinin poliçe sürecini kolaylaştırarak avantaj sağlar.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Mutuel Sigorta Konut Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Konut Paket Sigortası kapsamında evinizi ve eşyalarınızı güvence altına alabilirsiniz. Konut sigortasından yararlanmak isteyen kişiler ister ev sahibi olsun ister kiracı bu paketi satın alabilirler. ',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Atlas Mutuel Konut Paket Sigortası Teminatları:</u></em></strong>',
          subList: [
            'Cam kırılması teminatı,',
            'Dolu teminatı,',
            'Dumanın vereceği zararlar,',
            'Elektriksel hasarlara bağlı gıda bozulması,',
            'Elektronik cihaz sigortası,',
            'Enkaz kaldırma giderleri,',
            'Ev çalışanları emniyeti su istimal,',
            'Ferdi kaza teminatı,',
            'Fırtına teminatı,',
            'Hasar sebebiyle gerçekleşecek ikametgâh değişikliği masrafları,',
            'Hırsızlık teminatı,',
            'İzolasyon eksikliği teminatı,',
            'Kar ağırlığı teminatı,',
            'Kara - hava - deniz taşıtları çarpması teminatı,',
            'Kazaen kırılma teminatı,',
            'Kıymetli eşya hırsızlık teminatı,',
            'Kira kaybı teminatı,',
            'Makine kırılması sigortası,',
            'Misafir eşyaları teminatı,',
            'Sel - su baskını teminatı,',
            'Terör ve grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler teminatı,',
            'Yangın - infilak mali sorumluluk teminatı,',
            'Yangın, yıldırım, infilak teminatı,',
            'Yer kayması teminatı.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Mutuel Sigorta İşyeri Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Atlas Mutuel İşyeri Sigortası satın alarak işyerinizdeki olası riskleri güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Poliçe kapsamında size koruma sağlayan durumlar son derece geniştir. İşyerinizde bina ve bina içindeki mal varlıklarınız, çalışanlarınız birçok riske karşı güvende olur.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Atlas Mutuel İşyeri Paket Sigortası Teminatları:</u></em></strong>',
          subList: [
            'Alçı tavan çökmesi sonucu zararlar,',
            'Alternatif işyeri masrafları teminatı,',
            'Cam kırılması teminatı,',
            'Deprem teminatı,',
            'Deprem ECS teminatı,',
            'Dolu teminatı,',
            'Duman teminatı,',
            'Elektronik cihaz sigortası (ECS),',
            'Emniyeti suistimal',
            'Enkaz kaldırma teminatı,',
            'Fırtına teminatı,',
            'Grev, lokavt, kargaşalık, halk hareketleri,kötü niyetli hareketler, terör teminatı,',
            'Hırsızlık teminatı,',
            'Hukuksal koruma teminatı,',
            'İş durması teminatı,',
            'İzolasyon eksikliği teminatları,',
            'Kar ağırlığı teminatı,',
            'Kara-hava taşıtları çarpması sonucunda oluşabilecek zararlar,',
            'Kasa hırsızlık teminatı,',
            'Kasa yangın teminatı,',
            'Kira kaybı teminatı,',
            'Makine kırılması teminatı,',
            'Otomatik bedel artışı,',
            'Sel su baskını teminatı,',
            'Taşınabilir ECS teminatı,',
            'Taşınan para teminatı,',
            'Yangın mali sorumluluk teminatı,',
            'Yangın söndürme masrafları,',
            'Yangın, yıldırım, infilak teminatı,',
            'Yeni yatırımlar teminatı,',
            'Yer kayması teminatı.'
          ]
        }
      ]
    },
    {
      title: 'Atlas Mutuel Sigorta Ferdi Kaza Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Beklenmedik durumlara ve ani gelişebilecek olayların riskine karşı Atlas Mutuel Ferdi Kaza Sigortası yaptırabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Ferdi kaza sigortası ani gelişen bir kaza sonucunda sigortalının vefat etmesini ya da sakat kalma ihtimalini güvence altına alır. ',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Atlas Mutuel Ferdi Kaza Sigortası Teminatları:</u></em></strong>',
          subList: [
            'Ölüm / Sakatlık Teminatı',
            'Tedavi Giderleri',
            'Gündelik Tazminat',
            'Deprem ',
            'Terör.'
          ]
        },
        {
          paragraph:
            'Ayrıca yukarıdaki teminatlar ile Grup Ferdi Kaza Sigortası kapsamında, işyerinizde çalışan personellerinizi tek bir poliçede ani ve harici oluşabilecek durumlara karşı güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Mutuel Sigorta Nakliyat Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası, ilgili malların bir yerden bir yere taşınması sırasında uğrayacağı zararları güvence alır.',
          subList: null
        },
        {
          paragraph:
            'Denizyolu, havayolu, karayolu ve demiryolu taşımacılığı yapan kişiler olası riskleri Atlas Mutuel Sigorta kapsamında güvence altına alabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Mutuel Sigorta Poliçe Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Atlas Mutuel Sigorta poliçe sorgulama yapmak isteyen sigortalılar şirketin web site adresini ziyaret etmelidir.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>alokasko.com </u></em></strong> üzerinden poliçe satın alan sigortalılarımız sigorta danışmanlarını arayarak sorgulama yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Mutuel Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Atlas Mutuel Sigorta hasar dosya sorgulama yapmak için şirketin resmi web sitesini ziyaret etmelisiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko sitesinden satın aldığınız sigorta ürünü kapsamında yaşadığınız hasarlar için uzmanlarımız size destek olmaktadır. Hasar dosya takip işlemleriniz için <strong><em><u>0216 371 67 77</u></em></strong> numaralı hattan danışmanınıza bağlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Mutuel Sigorta Poliçe Fiyatı Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Atlas Mutuel Sigorta ile anlaşmalı olan Alokasko web sitemiz üzerinden veya ( 0216 ) 371 67 77 numara üzerinden, uzman ekibimize bilgilerinizi iletebilir ve en uygun teklifleri alabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
